import { changedetails } from '../Actions/ActionTypes';

const initialState = {
    details: {
        total: 0,
        embassy_fees: 0,
        normal_fees: 0,
        express_fees: 0,
    },
}

const DetailsReducer = (state = initialState, action) => {
    switch(action.type){
        case changedetails: 
            return ({
                ...state,
                details: action.details
            })
        default :
            return state
    }

}

export default DetailsReducer;